import { ArrowRight, PartyPopper } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { urlDeLaTrivia } from './trivia'

/**
 * Tarjeta que lleva a la trivia semanal, para la pantalla de Novedades (goal
 * trivias-de-la-comunidad 5): quien entra ahí viene en modo «qué hay de
 * nuevo», que es justo cuando la trivia interesa.
 *
 * 🚨 El texto NO dice «tienes una trivia nueva»: el portal **no consulta** a la
 * comunidad (decisión 3 del goal), así que no lo sabe. Cuenta lo que sí es
 * cierto — que hay una trivia semanal y dónde está.
 *
 * Sin `VITE_COMUNIDAD_URL` no se renderiza nada.
 */
export function TarjetaTrivia() {
  const { t } = useTranslation()
  const url = urlDeLaTrivia()
  if (!url) return null

  return (
    <section className="mb-6 flex flex-col gap-4 rounded-card border border-line bg-panel p-5 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-full bg-brand/10 text-brand">
          <PartyPopper className="h-4 w-4" aria-hidden="true" />
        </span>
        <div>
          <h2 className="text-[15px] font-semibold text-ink">
            {t('trivia.tarjetaTitulo')}
          </h2>
          <p className="mt-0.5 text-sm text-ink-muted">
            {t('trivia.tarjetaTexto')}
          </p>
        </div>
      </div>

      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="group inline-flex shrink-0 items-center justify-center gap-2 self-start rounded-lg bg-brand px-4 py-2.5 text-[13.5px] font-semibold text-white transition-colors hover:bg-brand/90 sm:self-auto"
      >
        {t('trivia.tarjetaCta')}
        <ArrowRight
          className="h-4 w-4 transition-transform group-hover:translate-x-0.5"
          aria-hidden="true"
        />
        <span className="sr-only">{t('trivia.nuevaPestana')}</span>
      </a>
    </section>
  )
}
